<template>
<div id="contactme">
  <div class="back" id="backcont"></div>

  <form id="form" ref="form" @submit.prevent="sendEmail">
  <div id="contacth">I'm intersted in...... </div>

<div id="choose">
  <label>
   <input type="radio" name="mode" value="Website">
   <i>Website</i>
</label>
<label>
   <input type="radio" name="mode" value="FeedBack">
   <i>FeedBack</i>
</label>
<label>
   <input type="radio" name="mode" value="Inquiry">
   <i>Inquiry</i>
</label>
<label>
   <input type="radio" name="mode" value="Partnership">
   <i>Partnership</i>
</label>


</div>

    <input type="text" name="user_name" placeholder="Your name" autocomplete="off">
    <input type="email" name="user_email" placeholder="Your Email" autocomplete="off">
    <input type="text" name="message" placeholder="Tell me about your idea" autocomplete="off">

    <input type="submit" value="Send">
  </form>
  <div>
    <div id="contacth">Or Find me here :</div>
    <div>
      <div class="link"><a class="link" href="https://github.com/computerGuy11" target="_blank">GitHub</a></div>
      <div class="link"><a class="link" href="https://www.linkedin.com/in/khalil-t-19aa42191/" target="_blank">LinkdIn</a></div>
      <div class="link"><a class="link" href="https://www.facebook.com/profile.php?id=100083861916707" target="_blank">Facebook</a></div>

    </div>

  </div>
</div>

</template>

<script>
import emailjs from '@emailjs/browser';

export default {
  methods: {
    sendEmail() {
      emailjs.sendForm('service_sjptvyd', 'template_dkntrzn', this.$refs.form, 'EN75E7ggsCJItPD9Z')
        .then((result) => {
            console.log('SUCCESS!', result.text);
        }, (error) => {
            console.log('FAILED...', error.text);
        });
    }
  }
}
</script>